import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import index from '@/components/index'
// import Binding from '@/components/Binding'
// import BindingPhone from '@/components/BindingPhone'
import PopSpecifiedPage from '@/components/PopSpecifiedPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/PopSpecifiedPage/:res',
      name: 'PopSpecifiedPage',
      component: PopSpecifiedPage
    },
    // {
    //   path: '/binding/',
    //   name: 'binding',
    //   component: Binding
    // },
    // {
    //   path: '/bindingphone/',
    //   name: 'bindingphone',
    //   component: BindingPhone
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js